import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_LAST_SCORING_LOGS = createAsyncActionType(
  "GET_LAST_SCORING_LOGS"
);

export const SET_ITEMS_PER_PAGE_SCORING_LOGS = "SET_ITEMS_PER_PAGE_SCORING_LOGS";

export const SET_CURRENT_PAGE_SCORING_LOGS = "SET_CURRENT_PAGE_SCORING_LOGS";



// WEBPACK FOOTER //
// ./src/features/score-card/types/getLastScoringLogsTypes.js